import colors from '@/assets/theme/colors/hex/index.common';
import FlexContainer from '@/components/atomic/atoms/layout/flex-container/styled';
import View from '@/components/atomic/atoms/layout/view/styled';
import Cta from '@/components/atomic/atoms/navigation/cta/styled';
import styled from '@emotion/styled';

const WelcomeBanner = styled(View)(({ theme }) => ({
	width: '100%',
	background: theme.colors.primaryBrandColor,
	lineHeight: '19px',
	maxHeight: '69px',

	[`${theme.media.desktop.laptop}`]: {
		maxHeight: '50px',
	},
	[`${FlexContainer}`]: {
		color: theme.colors.primaryNavBackground,
		paddingTop: '15.5px',
		paddingBottom: '15.5px',
		paddingLeft: '30px',
		paddingRight: '30px',
		[`${theme.media.desktop.laptop}`]: {
			paddingLeft: '60px',
			paddingRight: '60px',
		},
		alignContent: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		height: '100%',
		span: {
			display: 'inline',
			textAlign: 'center',
			fontSize: '14px',
			marginRight: '10px',
			fontFamily: theme.font.families.secondary.default,
			letterSpacing: '0.2px',
			fontWeight: 400,
			WebkitFontSmoothing: 'antialiased',
		},
	},
	[`${Cta}`]: {
		display: 'inline',
		span: {
			fontSize: '14px',
			marginRight: 0,
			textDecorationLine: 'underline',
			fontFamily: theme.font.families.secondary.default,
			letterSpacing: '0.2px',
			fontWeight: 400,
			WebkitFontSmoothing: 'antialiased',
			textUnderlineOffset: '1px',
			backgroundColor: 'transparent',
		},
		'&:hover': {
			backgroundColor: 'transparent',
			span: {
				color: colors.white.hex(),
				textDecorationLine: 'none',
			},
		},
		':visited': {
			color: theme.colors.primaryNavBackground,
		},
	},
}));

export default WelcomeBanner;
